import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { SearchBarTable } from 'hljd'
import getColumns from './column'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { store } = this.props
    return (
      <>
        <SearchBarTable
          locale={{
            emptyText: (
              <>
                <img
                  src="//qnm.hunliji.com/FlPjIswr_sKsOsM4cIMftijvrYQg"
                  style={{ width: 200, height: 200 }}
                />
                <div
                  style={{
                    marginTop: 24,
                    color: '#666',
                    fontSize: 16,
                    fontWeight: 500
                  }}
                >
                  暂无数据
                </div>
              </>
            )
          }}
          columns={getColumns(store)}
          store={store}
        />
      </>
    )
  }
}
